var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.localePath(_vm.link)}},[_c('img',{staticClass:"inline anim_shadow h-full",attrs:{"src":_vm.logoPath,"alt":"AddCube Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }